/**
 * *************************
 * Email Routes Components *
 * *************************
 */
const ArchiveSearchSubMain = () =>
  import('@/components/ArchiveSearch/ArchiveSearchSubMain');
const EmailSearch = () => import('@/components/Organisations/EmailSearch');
const EmailSearchMain = () =>
  import('@/components/Organisations/EmailSearchMain');
const EmailTemplateArchives = () =>
  import('@/components/ArchiveSearch/EmailTemplateArchives');

export default {
  title: 'Email',
  path: 'email',
  link: '/archive-search/email/inbox/p1',
  component: ArchiveSearchSubMain,
  props: { index: 0 },
  meta: {
    id: 'archive-search__email-tab'
  },
  children: [
    {
      title: 'Inbox',
      link: '/archive-search/email/inbox/p1',
      path: 'inbox/p:pageNumber?',
      component: EmailSearch,
      meta: {
        fromType: 'inbox',
        subNav: 'email',
        id: 'archive-search__email__inbox-tab'
      },
      props: {
        type: 'inbox'
      }
    },
    {
      title: 'Sent',
      link: '/archive-search/email/sent/p1',
      path: 'sent/p:pageNumber?',
      component: EmailSearch,
      meta: {
        fromType: 'sent',
        subNav: 'email',
        id: 'archive-search__email__sent-tab'
      },
      props: {
        type: 'sent'
      }
    },
    {
      title: 'Spam',
      link: '/archive-search/email/spam/p1',
      path: 'spam/p:pageNumber?',
      component: EmailSearch,
      permission: [
        {
          action: 'view',
          entity: 'spam'
        }
      ],
      meta: {
        fromType: 'spam',
        subNav: 'email',
        permission: [
          {
            action: 'view',
            entity: 'spam'
          }
        ],
        id: 'archive-search__email__spam-tab'
      },
      props: {
        type: 'spam'
      }
    },
    {
      path: 'inbox/:archiveId',
      component: EmailTemplateArchives,
      meta: {
        fromType: 'inbox',
        subNav: 'email'
      }
    },
    {
      path: 'spam/:archiveId',
      component: EmailTemplateArchives,
      meta: {
        fromType: 'spam',
        subNav: 'email'
      }
    },
    {
      path: 'sent/:archiveId',
      component: EmailTemplateArchives,
      meta: {
        fromType: 'sent',
        subNav: 'email'
      }
    },
    {
      title: 'Organization Email',
      link: '/archive-search/email/org/p1',
      permission: [
        {
          action: 'search',
          entity: 'organisation_email'
        }
      ],
      path: 'org',
      component: EmailSearchMain,
      meta: {
        permission: [
          {
            action: 'search',
            entity: 'organisation_email'
          }
        ],
        id: 'archive-search__email__organization-email-tab'
      },
      children: [
        {
          path: '',
          redirect: '/archive-search/email/org/p1'
        },

        {
          path: 'p:pageNumber?',
          component: EmailSearch,
          meta: { subNav: 'email' },
          props: { type: 'email-org' }
        },

        {
          path: ':archiveId',
          component: EmailTemplateArchives,
          meta: {
            subNav: 'email',
            permission: [
              {
                action: 'search',
                entity: 'organisation_email'
              }
            ]
          },
          props: { type: 'email-org' }
        }
      ]
    }
  ]
};
